export default __webpack_public_path__ + "static/41-fit-d4a9767d88521c0ba00ed75e820eb886.png";